import * as React from "react";
import { cn } from "@/shared/lib/utils";

interface ISmallButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    active: boolean
    className?: string,
}

const SmallButton = React.forwardRef<HTMLButtonElement, ISmallButtonProps>(
    ({children, active, className, ...props }, ref) => {

        const [pressed, setPressed] = React.useState<boolean>(false);
        const [hovered, setHovered] = React.useState<boolean>(false);

        return (
            <button
                ref={ref}
                className={cn(
                    "h-[26px] text-black px-[8px] font-manrope text-[14px] font-medium rounded-full flex justify-center items-center",
                    className,
                    hovered && "text-white bg-light-blue",
                    (pressed || active) && "text-white bg-blue-70"
                )}
                {...props}
                onMouseDown={()=>setPressed(true)}
                onMouseUp={()=>setPressed(false)}
                onMouseEnter={()=>setHovered(true)}
                onMouseLeave={()=>{setPressed(false); setHovered(false)}}
                
                onTouchStart={()=>setPressed(true)}
                onTouchEnd={()=>setPressed(false)}
            >
                {children}
            </button>
        );
    }
);

SmallButton.displayName = "SmallButton";

export default SmallButton;